

const chartColumns = () => {
    const debug = true
    debug ? console.log('chartColumns JS') : ''
    const chartColumns = [...document.querySelectorAll('.js-chart-columns')];

    if(!chartColumns) return

    // Two column chart?
    const isTwoColChart = (elem) => {
     return elem.classList.contains('-two-charts');
    }

    const chartColConnector = (elem) => {
        let connector = elem.querySelector('[data-chart-connect]')
        if(!connector) return
        let index = connector.dataset.chartConnect
        let targetChartCol = elem.firstElementChild.querySelectorAll('.chart__data')[index - 1]
        let topVal = targetChartCol.offsetTop // top pos from parent
        let targetChartColHeight = targetChartCol.offsetHeight // height of target elem
        const _topVal = topVal / 400 * 100
        let currentChartCol = elem.querySelector('[data-chart-connect]')
        let topVal2 = currentChartCol.offsetTop
        let currentElHeight = currentChartCol.offsetHeight
        // percentage value of Bottom of el from Top of chart
        let curBot = currentElHeight + topVal2;
        const _curBot = curBot / 400 * 100 // 80
        let targetBot = targetChartColHeight + topVal;
        const _tarBotPer = targetBot / 400 * 100

        return `polygon(100% ${topVal2}%, 100% ${_curBot}%, 0 ${_tarBotPer}%, 0 ${_topVal}%)`;
    }

    // TODO: Promise resolve.all here instead of setTimeout
    const chartCellAnimations = (chart) => {
        const chartCells = [...chart.querySelectorAll('.chart__data--inner')];
        if(!chartCells) return;
        const lastChartCell = chartCells.slice(-1)[0]
        lastChartCell.addEventListener('transitionend', () => {
            chart.classList.add('-animated');
        }, {once:true})
    }

    chartColumns.forEach((chartCol) => {
        debug ? console.log('chartColumns col ', chartCol) : ''
        const hasTwoCharts = isTwoColChart(chartCol);
        if(hasTwoCharts) {
           const clipPathValue = chartColConnector(chartCol)
            const colConnectorEl = chartCol.querySelector('.chart-column-connector')
            if(colConnectorEl){
                colConnectorEl.style.clipPath = clipPathValue
            }
        }
        chartCellAnimations(chartCol)
    })

}
chartColumns()

